// https://account.mapbox.com/access-tokens
// "Default public token"
export const apiKeyMapbox =
  'pk.eyJ1IjoiaGVqY28iLCJhIjoiY2piZjd2bzk2MnVsMjJybGxwOWhkbWxpNCJ9.L1UNUPutVJHWjSmqoN4h7Q'

// https://www.mapillary.com/dashboard/developers
// "Tarmac OSM Viewer", they call it "Client Token"
export const apiKeyMapillary = 'MLY|5337311709720950|61508fdcc416406fd8dfb79748463852'
